module.exports = __webpack_public_path__ + "img/w3_circle_in_stock_light.f010a1b2.png";